<template>
  <div class="our-mision-area bg-gray3">
    <div class="container mw-1356">
      <div class="row g-0">
        <div class="col-xl-6">
          <div class="our-mision-content ptb-100 ms-0">
            <span class="top-title">مهمتنا</span>
            <h2>رسالتنا في تقديم أفضل خدمة IPTV</h2>
            <div class="row">
              <div class="col-lg-6 col-sm-6">
                <ul class="ps-0 mb-0 list-unstyled mission-list">
                  <li class="d-flex align-items-center">
                    <i class="ti ti-circle-check"></i>
                    <span>تجربة مشاهدة سلسة</span>
                  </li>
                  <li class="d-flex align-items-center">
                    <i class="ti ti-circle-check"></i>
                    <span>أعلى جودة للبث (4K/HD)</span>
                  </li>
                  <li class="d-flex align-items-center">
                    <i class="ti ti-circle-check"></i>
                    <span>ابتكار تقني مستمر</span>
                  </li>
                  <li class="d-flex align-items-center">
                    <i class="ti ti-circle-check"></i>
                    <span>دعم فني مخصص للعملاء</span>
                  </li>
                  <li class="d-flex align-items-center">
                    <i class="ti ti-circle-check"></i>
                    <span>حماية وخصوصية البيانات</span>
                  </li>
                  <li class="d-flex align-items-center">
                    <i class="ti ti-circle-check"></i>
                    <span>استقرار وثبات الخدمة</span>
                  </li>
                  <li class="d-flex align-items-center">
                    <i class="ti ti-circle-check"></i>
                    <span>تنوع وشراكات واسعة</span>
                  </li>
                </ul>
              </div>
              <div class="col-lg-6 col-sm-6">
                <ul class="ps-0 mb-0 list-unstyled mission-list">
                  <li class="d-flex align-items-center">
                    <i class="ti ti-circle-check"></i>
                    <span>أسعار تنافسية ومناسبة</span>
                  </li>
                  <li class="d-flex align-items-center">
                    <i class="ti ti-circle-check"></i>
                    <span>تفاعل مجتمعي نشط</span>
                  </li>
                  <li class="d-flex align-items-center">
                    <i class="ti ti-circle-check"></i>
                    <span>سهولة الوصول للمحتوى</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-6">
          <div class="our-mision-img">
            <img src="@/assets/images/our-mision.jpg" alt="our-mision" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  // اسم متعدد الكلمات لتجنب خطأ ESLint
  name: "CompanyMission",
});
</script>